<template>
    <div>
        <van-collapse v-model="activate" @change="collapseChange">
            <van-collapse-item title="借款信息">
                <van-field
                        clearable
                        label="类型"
                        label-width="100px"
                        input-align="left"
                        :value="applyInfo.itemTypeCn"
                        readonly
                />
                <van-field
                        clearable
                        label="借款金额"
                        label-width="100px"
                        input-align="left"
                        :value="applyInfo.borrowAmount | amountFormat('元')"
                        readonly
                />
                <van-field
                        clearable
                        label="借款期限"
                        placeholder="请输入借款期限"
                        label-width="100px"
                        input-align="left"
                        :value="applyInfo.borrowTerm | approveNoFormat(applyInfo.rateUnit)"
                        readonly
                />
                <van-field
                        clearable
                        label="利率单位"
                        label-width="100px"
                        input-align="left"
                        :value="applyInfo.rateUnit | rateUtilConversion"
                        readonly
                />
                <van-field v-if="applyInfo.rateUnit=='day'"
                        clearable
                        label="日服务费率"
                        label-width="100px"
                        input-align="left"
                        :value="applyInfo.dayServiceRate | numNull('%') "
                        readonly
                />
                <van-field v-if="applyInfo.rateUnit=='month'"
                           clearable
                           label="年服务费率"
                           label-width="100px"
                           input-align="left"
                           :value="applyInfo.platformrate | numNull('%') "
                           readonly
                />
                <van-field
                        clearable
                        label="借款利率"
                        label-width="100px"
                        input-align="left"
                        :value="applyInfo.applyRate | numNull('%') "
                        readonly
                />
                <van-field v-if="applyInfo.nominalRate>0"
                           clearable
                           label="销售结算利率"
                           label-width="120px"
                           input-align="left"
                           :value="applyInfo.nominalRate | numNull('%')"
                           readonly
                />
                <van-field
                        clearable
                        label="批准金额"
                        label-width="100px"
                        input-align="left"
                        :value="applyInfo.approveAmt | amountFormat('元')"
                        readonly
                />
                <van-field
                        clearable
                        label="预计出款时间"
                        label-width="100px"
                        input-align="left"
                        :value="applyInfo.paymentDate | dateFormat"
                        readonly
                />
                <van-field
                        clearable
                        label="批准期限"
                        label-width="100px"
                        input-align="left"
                        placeholder="请输入批准期限"
                        :value="applyInfo.approveNo | approveNoFormat(applyInfo.rateUnit)"
                        readonly
                />
                <van-field
                        clearable
                        label="批准利率"
                        :value="applyInfo.approveRate | numNull('%') "
                        readonly
                />
                <van-field v-if="applyInfo.fundingFlag"
                        clearable
                        label="是否配资"
                        label-width="100px"
                        input-align="left"
                        :value="applyInfo.fundingFlag"
                        readonly
                />
                <van-field v-if="applyInfo.fundingFlag=='是'"
                        clearable
                        label="配资金额"
                        label-width="100px"
                        input-align="left"
                        :value="applyInfo.fundingAmount| amountFormat('元')"
                        readonly
                />
                <van-field v-if="applyInfo.fundingFlag=='是'"
                           clearable
                           label="我司出资金额"
                           label-width="100px"
                           input-align="left"
                           :value="(parseInt(applyInfo.approveAmt)-parseInt(applyInfo.fundingAmount))| amountFormat('元')"
                           readonly
                />
                <van-field v-if="applyInfo.accruedAmount"
                        clearable
                        :label="applyInfo.firstAdvanceTime!=null?'放款金额':'预放款金额'"
                        label-width="100px"
                        input-align="left"
                        :value="applyInfo.accruedAmount| amountFormat('元')"
                        readonly
                />
                <van-field
                        clearable
                        label="借款描述"
                        type="textarea"
                        autosize
                        readonly
                        :value="applyInfo.remark"
                />

            </van-collapse-item>

            <van-collapse-item title="个人信息">
                <van-field
                        clearable
                        label="借款人"
                        :value="customer.customerName"
                        readonly
                />
                <van-field
                        clearable
                        label="出生日期"
                        :value="customer.customerBirthday | dateFormat"
                        readonly
                />
                <van-field
                        clearable
                        label="性别"
                        :value="customer.customerGender == '1' ? '男':'女' "
                        readonly
                />
                <van-field
                        clearable
                        type="textarea"
                        autosize
                        readonly
                        label="现居地址"
                        :value="customerDetail.userAddressProvice + customerDetail.userAddressCity  + ',' +  customerDetail.userAddress"
                />
                <van-field
                        clearable
                        type="text"
                        autosize
                        label="婚姻情况"
                        readonly
                        :value="customerDetail.customerMaritalStatusCN"
                />
                <van-field
                        clearable
                        type="text"
                        autosize
                        label="家庭年收入"
                        readonly
                        :value="customerDetail.userIncome | amountFormat('元')"
                />
            </van-collapse-item>

            <van-collapse-item title="抵押物信息">
                <van-field
                        clearable
                        type="text"
                        label="产权人"
                        readonly
                        :value="house.propertyPerson"
                />
                <van-field
                        clearable
                        type="text"
                        label="产权证号"
                        readonly
                        :value="house.propertyCardNumber"
                />
                <van-field
                        clearable
                        type="text"
                        readonly
                        label="面积(㎡)"
                        :value="house.houseArea"
                />
                <van-field
                        clearable
                        type="text"
                        readonly
                        label="参考价(万)"
                        :value="house.houseReferencePrice"
                />
                <van-field
                        clearable
                        type="text"
                        readonly
                        label="小区名称"
                        :value="house.estateName"
                />
                <van-field
                        clearable
                        type="text"
                        readonly
                        label="建造时间"
                        :value="house.houseCreateTime | dateFormat"
                />
                <van-field
                        clearable
                        type="text"
                        readonly
                        label="房产类型"
                        :value="house.housePurposeCN"
                />
                <van-field
                        clearable
                        type="textarea"
                        autosize
                        readonly
                        label="地址"
                        :value="house.province + house.city + house.district + house.detailedAdress"
                />
            </van-collapse-item>

            <van-collapse-item v-for="(bank,index) in banks"  title="客户赎楼银行信息" >
                <van-field
                        clearable
                        label="开户姓名"
                        :value="bank.accountName"
                        readonly
                />
                <van-field
                        clearable
                        label="银行卡号"
                        :value="bank.bankAccount"
                        readonly
                />
                <van-field
                        clearable
                        label="银行名称"
                        :value="bank.cnBankName"
                        readonly
                />
                <van-field
                        clearable
                        label="开户行"
                        :value="bank.customerBankProvince + bank.customerBankCity + bank.accountBankName"
                        readonly
                />
            </van-collapse-item>

            <van-collapse-item v-for="(item,index) in applyBanks" title="客户回款银行信息" >
                <van-field
                        clearable
                        label="开户姓名"
                        :value="item.applyAccountName"
                        readonly
                />
                <van-field
                        clearable
                        label="银行卡号"
                        :value="item.applyBankAccount"
                        readonly
                />
                <van-field
                        clearable
                        label="银行名称"
                        :value="item.applyBankNameCn"
                        readonly
                />
                <van-field
                        clearable
                        label="开户行"
                        :value="item.applyBankProvince + item.applyBankCity + item.applyAccountBankName"
                        readonly
                />
            </van-collapse-item>

            <van-collapse-item  title="时间节点" >
                <van-field
                        clearable
                        label="预计扣款时间"
                        label-width="100"
                        :value="applyInfo.deductionDay|dateYmdFormat"
                        readonly
                />
                <van-field
                        clearable
                        label="预计涂销时间"
                        label-width="100"
                        :value="applyInfo.marketingDay|dateYmdFormat"
                        readonly
                />
                <van-field
                        clearable
                        label="预计过户时间"
                        label-width="100"
                        :value="applyInfo.transferDate|dateYmdFormat"
                        readonly
                />
                <van-field
                        clearable
                        label="预计入押时间"
                        label-width="100"
                        :value="applyInfo.admissionDay|dateYmdFormat"
                        readonly
                />
            </van-collapse-item>

        </van-collapse>

    </div>
</template>

<script>
    import Vue from 'vue'
    import { AUDIT_STATUS } from '@/vue/store/mutation-type'
    import { getForeclosureApplyInfo } from '@/api/loanInfo'
    import { eventBus } from '../../../../vue/utils/eventBus'
    import store from '@/vue/store'

    export default {
        name: 'loan-info',
        props: {
            applyId: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                activate: [],
                applyInfo: {},
                customer: {},
                customerDetail: {},
                banks: [],
                applyBanks: [],
                house: {},
            }
        },
        mounted() {
            this.loadData()
        },
        methods: {
            collapseChange(array) {
            },
            loadData() {
                let self = this
                getForeclosureApplyInfo({applyId: this.applyId}).then(res => {
                    if (res.success) {
                        self.applyInfo = res.applyInfo
                        self.customer = res.customer
                        self.customerDetail = res.customerDetail
                        self.banks = res.bank
                        self.house = res.house
                        self.applyBanks = res.applyBanks
                        self.$parent.$parent.$parent.approveAmt = res.applyInfo.approveAmt
                        self.$parent.$parent.$parent.$parent.$data.itemType=res.applyInfo.itemType
                        //处理当前进件状态
                        let expire = 7 * 24 * 60 * 60 * 1000
                        Vue.ls.set(AUDIT_STATUS, self.applyInfo.auditStatus, expire)
                        store.commit('SET_AUDIT_STATUS', Vue.ls.get(AUDIT_STATUS))
                        eventBus.$emit('auditStatus',self.applyInfo.auditStatus)
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
